import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-center relative"
};
const _hoisted_2 = {
  class: "absolute text-white text-4xl font-bold top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
};
import ActionScreen from "@/modules/action-screens/components/ActionScreen.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerProgressActionScreen',
  props: {
    player: null
  },
  emits: ['finished'],
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createBlock(ActionScreen, _mergeProps(_ctx.$attrs, {
        onFinished: _cache[0] || (_cache[0] = $event => _ctx.$emit('finished'))
      }), {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(__props.player.name), 1)]),
        subTitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('player_progressed')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.Star16Filled,
          class: "text-yellow-400",
          size: "4.5rem"
        }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_2, _toDisplayString(__props.player.level), 1)])]),
        _: 1
      }, 16);
    };
  }
});